/**
 * 系统日志管理 API
 * 
 * 提供日志文件查询和内容查看功能
 * 
 * @author AI Assistant
 * @created 2025-11-15
 */

import httpRequest from '@/utils/api'
import type {
  LogFileListResponseData,
  LogContentResponseData,
  LogContentParams,
} from '@/types/admin/logs'

enum API {
  logFiles = '/admin/logs/files',
  logContent = '/admin/logs/content',
}

/**
 * 获取日志文件列表
 * 
 * @returns 日志文件列表响应
 */
export const getLogFilesAPI = () => {
  return httpRequest.get<LogFileListResponseData>({
    url: API.logFiles,
  })
}

/**
 * 获取日志文件内容
 * 
 * @param params 查询参数
 * @returns 日志内容响应
 */
export const getLogContentAPI = (params: LogContentParams) => {
  return httpRequest.get<LogContentResponseData>({
    url: API.logContent,
    params,
  })
}

